import { render, staticRenderFns } from "./GraphMDB.vue?vue&type=template&id=651a2a28&"
import script from "./GraphMDB.vue?vue&type=script&lang=js&"
export * from "./GraphMDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports